module.exports = __webpack_public_path__ + "static/secondary-logo-675337df1d2609581adcdc62f6638eca.svg";